// GetBasketPage returns all the needed information to be displayed on the basket.
//
// It requires a full session, so either a guest session or a customer session.
export const BasketPageService_GetBasketPageBulkLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_GetBasketPageBulk);
BasketPageService_GetBasketPageBulkLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/GetBasketPageBulk" as const;

// ChangeQuantity updates the selected quantity for an existing basket item.
//
// In case the basket item can't be found, a NOT_FOUND error is returned.
//
// In case the item became out of stock or doesn't have enough quantity,
// the request will be succesful with an embedded error in the response.
// See the `ChangeQuantityResponse` for more information.
export const BasketPageService_ChangeQuantityLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_ChangeQuantity);
BasketPageService_ChangeQuantityLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/ChangeQuantity" as const;

// ChangeSize changes the size of an existing basket item in the basket.
// This essentially means we remove a basket item and add a new one with the new size.
//
// In case the existing basket item or new size can't be found, a NOT_FOUND error is returned.
//
// In case the new size is out of stock or has not enough quantity, the new basket state is returned
// and an additional error in the response.
// Check the `ChangeSizeResponse` for more details.
export const BasketPageService_ChangeSizeLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_ChangeSize);
BasketPageService_ChangeSizeLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/ChangeSize" as const;

// RemoveItem is used when the user removes an item from the basket.
//
// In case the basket item key can't be found, a NOT_FOUND error will be returned.
export const BasketPageService_RemoveItemLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_RemoveItem);
BasketPageService_RemoveItemLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/RemoveItem" as const;

// GetCoupons for an item in the basket including post coupon total prices.
//
// In case the product can't be found, a NOT_FOUND error will be returned.
export const BasketPageService_GetCouponsLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_GetCoupons);
BasketPageService_GetCouponsLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/GetCoupons" as const;

// Get wishlist and last seen product recommendations on Basket Page
export const BasketPageService_GetRecommendationsLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_GetRecommendations);
BasketPageService_GetRecommendationsLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/GetRecommendations" as const;

// SetResaleBagOption is used when the user wants to get a free resale bag with his order.
export const BasketPageService_SetResaleBagOptionLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_SetResaleBagOption);
BasketPageService_SetResaleBagOptionLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/SetResaleBagOption" as const;

// AddItem adds a new item to the basket.
// In case the item is out of stock or has not enough quantity, the new basket state is returned
// If the item is already present in the basket the qty will be increased.
// This method will also return the basket sections und should therefore only be called on the basket page itself
export const BasketPageService_AddItemLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_AddItem);
BasketPageService_AddItemLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/AddItem" as const;

// Applies the given coupon to all the basket items given:
// - there is no active campaign or a PD for that customer
// - the coupon is assigned to the user (guest or customer)
// - the basket item is eligible for the coupon AND the basket item has no OR has a lower value coupon applied
export const BasketPageService_ApplyCouponLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_ApplyCoupon);
BasketPageService_ApplyCouponLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/ApplyCoupon" as const;

// Remove coupons on all the basket items given.
// In case the basket item doesn't have a coupon applied, it will be ignored.
// In case the basket item key can't be found, a NOT_FOUND error will be returned.
export const BasketPageService_RemoveCouponLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_RemoveCoupon);
BasketPageService_RemoveCouponLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/RemoveCoupon" as const;

// PriceRiseHint is used to check and alert
// if removing an item would increase the amount payble by making the basket ineligible for mov coupon
export const BasketPageService_PriceRiseHintLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_PriceRiseHint);
BasketPageService_PriceRiseHintLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/PriceRiseHint" as const;

// Endpoint to either redeem or remove coins depending on if there is a basket level coupon
// already applied to the basket or not
export const BasketPageService_ToggleCoinsLazy = () =>
  import("./service.grpc").then((m) => m.BasketPageService_ToggleCoins);
BasketPageService_ToggleCoinsLazy.method =
  "aysa_api.services.basket.v1.page.BasketPageService/ToggleCoins" as const;
